import { createStyles, makeStyles } from '@material-ui/core';
import { TranquiTheme } from '../App/theme';

export const useStylesIdConfirmation = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    padding: 0,
    margin: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      height: 'inherit',
      flexDirection: 'row',
    },
  },
  backBtn: {
    color: theme.palette.lavender.main,
    fontWeight: 600,
    marginRight: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .btnIcon': {
      marginRight: theme.spacing(1.5),
    },
  },
  bodyTitle: {
    color: theme.palette.indigo.main,
    fontSize: 20,
  },
  description: {
    color: theme.palette.text4.main,
  },
  loginWrapper: {
    padding: theme.spacing(3),
    flexGrow: 1,
    backgroundColor: theme.palette.bg4.default,
    [theme.breakpoints.up('md')]: {
      backgroundColor: 'transparent',
      width: '50%',
      padding: theme.spacing(5),
    },
    [theme.breakpoints.up('lg')]: {
      width: '30%',
      padding: theme.spacing(10),
    },
    display: 'flex',
    flexDirection: 'column',
    '& .title .description': {
      margin: theme.spacing(2, 0),
    },
    '& .selectDocument': {
      width: 'inherit',
    },
  },
  logosWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(4, 0, 6, 0),
    '& .greenDivider': {
      border: `1px solid${theme.palette.primary.main}`,
      margin: theme.spacing(0, 3),
    },
  },
  welcomeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& .welcomeImgWrapper': {
      backgroundColor: theme.palette.bg4.default,
      display: 'flex',
      borderRadius: '25px',
      flexGrow: 1,
      margin: theme.spacing(2),
      '& img': {
        margin: 'auto',
        width: '90%',
      },
    },
    '& .certificationText': {
      borderRight: `1px solid ${theme.palette.text4.main}`,
      paddingRight: theme.spacing(5),
    },
  },
  box: {
    margin: 'initial',
    height: 'auto',
  },
  btnWrappers: {
    display: ' flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  alert: {
    backgroundColor: theme.palette.pearl.main,
  },
  title: {
    ...theme.typography.h1,
    color: theme.palette.indigo.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      lineHeight: 1.2,
    },
  },
  text: {
    ...theme.typography.body2,
    color: theme.palette.text4.main,
  },
  textError: {
    ...theme.typography.small as any,
    color: theme.palette.salmon.main,
  },
}));

export type IdentificationConfirmationStyles = ReturnType<typeof useStylesIdConfirmation>;
